import { UploadId } from '../../../upload/Upload';
import { IAuditDataWithChannel } from '../../../publish/audit';
import { ApiRoute, HttpMethod } from '../../../common/api/routes';
import { LocationId } from '../../../location/Location';
import { LinkedIn } from '../../constants';
import { WorkflowStartResult } from '../../../external/aws/stepFunctions';
import { IPublishImageRequest } from '../../../publish/image';
import { RoleType } from './models/account';
import { LinkedInOrganizationData, OrganizationAccessControlElement } from './models/organization';

/**
 * See https://www.linkedin.com/pulse/maximum-character-limits-counts-linkedin-2018-eric-johnson/
 * for relevant info. Looks up to date and recent enough
 */

export const MAX_COMMENTARY_TEXT_LENGTH = 3000;

export interface LinkedInPublishData {
    comment?: string;
    scheduledTime?: Date | null;
}

export type ILinkedInPublishRequest = IPublishImageRequest<LinkedInPublishData>

export type PublishImageToLinkedInWorkflowInput = {
    channelData: LinkedInPublishData;
    uploadIds: UploadId[];
    auditData: IAuditDataWithChannel;
    scheduledTime: Date;
};

export type PublishImageToLinkedInWorkflowInputDeprecated = {
    channelData: LinkedInPublishData;
    uploadId: UploadId;
    auditData: IAuditDataWithChannel;
    scheduledTime: Date;
};

export type GetLinkedInPageNameAndOrganizationUrnResponse = {
    pageName: string;
    organizationUrn: string;
};

export function isDeprecatedPublishImageToLinkedInWorkflowInput(
    obj: PublishImageToLinkedInWorkflowInput | PublishImageToLinkedInWorkflowInputDeprecated,
): obj is PublishImageToLinkedInWorkflowInputDeprecated {
    return !!(obj as PublishImageToLinkedInWorkflowInputDeprecated).uploadId;
}

export function canLinkedInAccountPublishOnPage(
    userAdminPages: OrganizationAccessControlElement[],
    linkedInOrganizationUrn: string,
): boolean {
    return (
        userAdminPages.filter(
            pages =>
                pages.organization === linkedInOrganizationUrn &&
                pages.role === RoleType.administrator &&
                pages.state === 'APPROVED',
        ).length === 1
    );
}

export const LinkedInEndpoints = {
    canPostForLocation: new ApiRoute<{ result: boolean }, { locationId: LocationId }, void, void>(
        HttpMethod.Get,
        path =>
            path.literal('publish').literal(LinkedIn.name).literal('location').param('locationId').literal('hasAccess'),
    ),

    getAdminOrganizationsData: new ApiRoute<LinkedInOrganizationData[], { locationId: LocationId }, void, void>(
        HttpMethod.Get,
        path =>
            path
                .literal('integration')
                .literal(LinkedIn.name)
                .literal('location')
                .param('locationId')
                .literal('pages')
                .literal('data'),
    ),

    publishPhoto: new ApiRoute<WorkflowStartResult, { locationId: LocationId }, ILinkedInPublishRequest, void>(
        HttpMethod.Post,
        path => path.literal('publish').literal(LinkedIn.name).literal('location').param('locationId').literal('photo'),
    ),

    updateConfiguration: new ApiRoute<void, { locationId: LocationId }, { orgUrn: string }, void>(
        HttpMethod.Post,
        path => path.literal('integeration').literal(LinkedIn.name).literal('location').param('locationId'),
    ),
};
